import React from "react";
import { Check, AlertTriangle, AlertCircle } from "lucide-react";
import colorGroups from "./__ColorGroups";
import ShowGroupColors from "./__ShowGroupColors";

const statusColors = colorGroups.find(
  (group) => group.group === "Status Colors"
);

const StatusSection: React.FC = () => (
  <div className="w-full flex flex-col bg-bg-light px-4">
    <div className="container mx-auto max-w-4xl py-20">
      <div className="flex items-center justify-center">
        <img
          src="/images/logo-square.png"
          alt="RepMates logo"
          width="512"
          height="512"
          className="w-24 h-auto"
        />
      </div>

      <h1 className="text-5xl md:text-7xl font-extrabold text-tx-dark text-center leading-tight mb-10">
        Status Colors
      </h1>

      <div className="w-full grid grid-cols-1 gap-4 bg-bg-base rounded-lg p-4 md:p-20 mb-10">
        <div className="flex items-center gap-3 p-4 rounded-md bg-status-bg-success text-status-fg-success border border-status-bd-success">
          <Check
            className="w-6 h-6 text-status-icon-success"
            aria-label="Success"
          />
          <span>OK : Your action has been completed.</span>
        </div>
        <div className="flex items-center gap-3 p-4 rounded-md bg-status-bg-caution text-status-fg-caution border border-status-bd-caution">
          <AlertTriangle
            className="w-6 h-6 text-status-icon-caution"
            aria-label="Attention"
          />
          <span>Attention: Please check your information.</span>
        </div>
        <div className="flex items-center gap-3 p-4 rounded-md bg-status-bg-error text-status-fg-error border border-status-bd-error">
          <AlertCircle
            className="w-6 h-6 text-status-icon-error"
            aria-label="Error"
          />
          <span>Error: Something went wrong. </span>
        </div>
      </div>

      <div className="w-full bg-bg-base rounded-lg p-4 md:p-20">
        {statusColors && (
          <ShowGroupColors
            colorGroup={statusColors}
            gridColsClass="md:grid-cols-1"
          />
        )}
      </div>
    </div>
  </div>
);

export default StatusSection;
